import React, { useEffect, useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import {
  Breadcrumb,
  Carregando,
  ErroContainerLayout,
  ErroLayoutContainer,
  IconeDadosPessoais,
  IconePagamentoMatricula,
  IconeTermosCondicoes,
  Wizard
} from 'src/componentes'
import { RotasApp } from 'src/rotas'
import { RotasRescisaoAluno } from 'src/rotas/rescisao'
import { Api } from 'src/servicos'
import { StatusRescisao } from 'src/tipos'

import RescisaoContainer from './container'
import { EtapaAvisos } from './etapas/avisos'
import { EtapaDados } from './etapas/dados'
import { EtapaValores } from './etapas/valores'
import { Cabecalho, Container, Icone } from './styles'

const ComponenteWizard: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const {
    passo,
    definirPasso,
    definirProtocolo,
    definirDadosSolicitacao
  } = RescisaoContainer.useContainer()
  const [pronto, definirPronto] = useState(false)
  const [passoInicial, definirPassoInicial] = useState(1)
  const { definirErro, erro } = ErroLayoutContainer.useContainer()

  const listaWizard = useMemo(
    () => [
      {
        id: 'etapa-avisos',
        titulo: 'Avisos',
        icone: <Icone>{IconeTermosCondicoes}</Icone>,
        corpo: <EtapaAvisos />
      },
      {
        id: 'etapa-dados',
        titulo: 'Dados da solicitação',
        icone: <Icone>{IconeDadosPessoais}</Icone>,
        corpo: <EtapaDados />
      },
      {
        id: 'etapa-valores',
        titulo: 'Valores',
        icone: <Icone>{IconePagamentoMatricula}</Icone>,
        corpo: <EtapaValores />
      }
    ],
    []
  )

  const carregar = async () => {
    try {
      definirPronto(false)

      const protocolo = await Api.ObterProtocoloAtivoDoAluno(id)

      if (!protocolo) {
        definirErro({
          mensagens: 'Você não possui um protocolo de rescisão em aberto.',
          acaoVoltar: () => history.push(RotasApp.Home)
        })
        return
      }

      definirProtocolo(protocolo)

      if (protocolo.status === StatusRescisao.AguardandoTermoRescisao) {
        history.replace(`${RotasRescisaoAluno.Termo}/${id}`)
        return
      }

      // Aluno já concluiu o wizard (protocolo avançou além de EmAberto/
      // AguardandoRespostaFormulario) e voltou a acessar o link de e-mail — mostra aviso em vez
      // de reabrir o wizard.
      if (
        protocolo.status !== StatusRescisao.EmAberto &&
        protocolo.status !== StatusRescisao.AguardandoRespostaFormulario
      ) {
        definirErro({
          mensagens: `Você está com o protocolo de rescisão de contrato nº ${protocolo.numeroProtocolo} em aberto e em breve nossa equipe estará fazendo contato com você.`,
          acaoVoltar: () => history.push(RotasApp.Home)
        })
        return
      }

      definirDadosSolicitacao({
        matriculaId: protocolo.matriculaId,
        motivoId: protocolo.motivoId,
        motivoDetalhado: protocolo.motivoDetalhado,
        motivoOutroTexto: protocolo.motivoOutroTexto,
        telefone: protocolo.telefone
      })

      const dadosCompletos = Boolean(protocolo.matriculaId && protocolo.motivoId)
      const passoResumido = dadosCompletos
        ? 3
        : protocolo.aceitouTermosIniciais
        ? 2
        : 1

      definirPassoInicial(passoResumido)
      definirPasso(passoResumido)
    } catch (error) {
      definirErro({
        mensagens: 'Não foi possível carregar o seu protocolo de rescisão.',
        acaoVoltar: () => history.push(RotasApp.Home)
      })
    } finally {
      definirPronto(true)
    }
  }

  useEffect(() => {
    carregar()
  }, [id]) //eslint-disable-line

  if (!pronto && !erro) {
    return <Carregando texto="Carregando rescisão..." />
  }

  if (erro) {
    return <ErroContainerLayout />
  }

  return (
    <Container>
      <Cabecalho>
        <Breadcrumb titulo="Rescisão de contrato" atalhos={[{ texto: 'Rescisão' }]} />
      </Cabecalho>
      <Wizard
        passo={passo}
        passoCompleto={passoInicial}
        listaWizard={listaWizard}
        name="wizard-rescisao"
      />
    </Container>
  )
}

export const PaginaRescisao: React.FC = () => (
  <RescisaoContainer.Provider initialState={{ passo: 1 }}>
    <ErroLayoutContainer.Provider>
      <ComponenteWizard />
    </ErroLayoutContainer.Provider>
  </RescisaoContainer.Provider>
)

export default PaginaRescisao
